import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateInspectorFeedbackMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Inspector_Feedback_Set_Input>;
}>;


export type UpdateInspectorFeedbackMutation = { __typename?: 'mutation_root', update_inspector_feedback_by_pk?: { __typename?: 'inspector_feedback', id: any, job_id: any, finding_id?: any | null, gap_item_id?: any | null, user_id: string, decision?: string | null, error_attribution?: string | null, comment?: string | null, created_at: any, updated_at: any } | null };


export const UpdateInspectorFeedbackDocument = gql`
    mutation updateInspectorFeedback($id: uuid!, $_set: inspector_feedback_set_input = {}) {
  update_inspector_feedback_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    job_id
    finding_id
    gap_item_id
    user_id
    decision
    error_attribution
    comment
    created_at
    updated_at
  }
}
    `;
export type UpdateInspectorFeedbackMutationFn = Apollo.MutationFunction<UpdateInspectorFeedbackMutation, UpdateInspectorFeedbackMutationVariables>;

/**
 * __useUpdateInspectorFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateInspectorFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectorFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectorFeedbackMutation, { data, loading, error }] = useUpdateInspectorFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateInspectorFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectorFeedbackMutation, UpdateInspectorFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInspectorFeedbackMutation, UpdateInspectorFeedbackMutationVariables>(UpdateInspectorFeedbackDocument, options);
      }
export type UpdateInspectorFeedbackMutationHookResult = ReturnType<typeof useUpdateInspectorFeedbackMutation>;
export type UpdateInspectorFeedbackMutationResult = Apollo.MutationResult<UpdateInspectorFeedbackMutation>;
export type UpdateInspectorFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateInspectorFeedbackMutation, UpdateInspectorFeedbackMutationVariables>;